// Todo fields start with DA:

const TRANSLATIONS_DA_OLD = {
  // Footer
  footer: {
    alert: {
      headline: "Klar til at komme i gang?",
      description:
        "Download vores Windows App og indtag førstepladserne i dag!",
      button: "Hent Windows App",
      link: "Læs mere",
    },
  },
  countdown: {
    endsIn: "slutter om",
    hasEnded: "er afsluttet",
    days: {
      plural: "dage",
      singular: "dag",
    },
    hours: {
      plural: "timer",
      singular: "time",
    },
    minutes: {
      plural: "minutter",
      singular: "minut",
    },
    seconds: {
      plural: "sekunder",
      singular: "sekund",
    },
  },
  days: {
    0: "Søn",
    1: "Man",
    2: "Tirs",
    3: "Ons",
    4: "Tors",
    5: "Fre",
    6: "Lør",
  },
  product: {
    discount: "Spar",
    btn: {
      label: "Se produktet",
    },
  },

  // Feed
  feed: {
    welcome_msg: "Velkommen tilbage, ",
  },

  // Overview archive (overview page banners + filters)| news, challenges, teams, gathers
  overview: {
    teams: {
      create_btn: "Opret et hold",
      desc: "DA Come together as a team to achieve great things!",
      headline: {
        mine: "Mine hold",
        new: "Udforsk",
      },
      badges: {
        mine: "Mine",
        new: "Udforsk",
      },
    },
    gathers: {
      create_btn: "Opret event",
      desc: "Saml dine venner eller dan nye venskaber!",
      headline: {
        mine: "Mine events",
        new: "Udforsk",
      },
      badges: {
        mine: "Mine",
        new: "Udforsk",
      },
    },
  },

  // About page
  about: {
    title: "About World of Gamers",
    desc: "World of Gamers is a global community platform where gamers engage with other gamers as well as well-known brands. We wish to enable gamers to engage with each other through several means. As a platform we provide rich functionality to support the needs of the individual gamer and organizations while offering a unique possibility for our cooperative partners to engage with their intended key audience.",
    subsection1: {
      header: "DA What we do",
      desc1:
        "DA World of Gamers (“WOG”) is a gaming community that carries the DNA of more than 15 years of shaping eSport in Denmark and the Nordics.",
      desc2:
        "DA WOG is a gaming community with regional activities. We are using the gamiDAcation of statistics to activate our user and give them the option to create content for the whole community in a easy and accessible manner.",
    },
    subsection2: {
      header: "DA Who we are",
      desc1:
        "DA We are a team of passionate gamers who played our role in creating a strong foundation for eSport and raising the bar.",
      desc2:
        "DA World of Gamers are based on the Nordic model with good values and ethics, and is born out of our passion for gaming and our ambition to create something unique that has the potential to elevate gaming and eSport and set new standards.",
    },
    subheader2: "DA Who we are",
    subheader3: "DA The Nordic model",

    list: {
      1: "DA Bringing people together physically and/or digitally",
      2: "DA Uniting people based on a healthy and responsible community",
      3: "DA The ability for all participants to grow and develop their skills",
      4: "DA Providing safe and good experiences for all participants",
      5: "DA Uniting participants regardless of age, gender, and social background",
      6: "DA Contributing to giving participants increased value in their life",
      7: "DA Good values and ethics by treating fellow participants nicely",
      8: "DA Promoting happiness and passion through all activities",
    },
  },

  // Not found
  not_found: {
    title: "404 Siden blev ikke fundet",
    desc: "Denne side eksisterer ikke, eller er ikke længere tilgængelig.",
    button: "Gå tilbage til WOG",
  },

  // help page
  help: {
    title: "DA Feedback",
    general_issues: {
      title: "DA General issues",
      desc: "DA Report issues that appeared during interacting with website:",
      list: {
        0: "DA using search DAeld",
        1: "DA create button",
        2: "DA navigation, etc.",
      },
    },
    sign_up: {
      title: "DA Sign up process",
      desc: "DA Report issues on creating an account: ",
      list: {
        0: "DA performance",
        1: "DA occuring errors",
        2: "DA problems connecting through Battle.net or Steam platform, etc.",
      },
    },
    profile: {
      title: "DA Profile page",
      desc: "DA Report issues on profile page: ",
      list: {
        0: "DA connecting games account",
        1: "DA adding to friends",
        2: "DA editing profile",
        3: "DA notiDAcations, etc.",
      },
    },
    create_challenge: {
      title: "DA Create a challenge",
      desc: "DA Report issues that appeared while creating a challenge: ",
      list: {
        0: "DA text formatting",
        1: "DA setting the dates",
        2: "DA choosing criterias, etc.",
      },
    },
    single_challenge: {
      title: "DA Single challenge",
      desc: "DA Report issues that appeared during interacting with single challenge page:  ",
      list: {
        0: "DA incorrect leaderboard",
        1: "DA wrong data",
        2: "DA participating in a challenge, etc.",
      },
    },
    challenge_overview: {
      title: "DA Challenges overview",
      desc: "DA Report issues that appeared during interacting with challenges overview page: ",
      list: {
        0: "DA incorrect leaderboard",
        1: "DA wrong data",
        2: "DA participating in a challenge, etc.",
      },
    },
  },
  // privacy policy
  privacy_policy: {},

  // terms of service
  term_of_service: {},

  // Basic Buttons text. other btn text's will be replaced with these for convenience
  //  comments next to it is where where specific ones can be found
  // words that are all capital should be capitalized in scss, not here.
  buttons: {
    upload: "Upload",
    save: "Gem",
    save_changes: "Gem ændringer",
    cancel: "Annuller",
    apply_theme: "Skift", // Theme picker
    remove_avatar: "Fjern billede", // Profile
    add_friend: "Tilføj ven", // Profile
    unfriend: "Fjern ven", // Profile
    manage_btn: "Rediger",
    follow: "Følg",
    unFollow: "Stop med at følge",
    log_in: "Log ind",
    log_out: "Log ud", // Navigation
    create: "Opret", // Navigation
    see_more: "Se mere", // Home
    go_back: "Gå tilbage", // Home
    join: "Tilslut", // Challenges cards
    get_started: "Kom i gang",
    try_btn: "Prøv nu",
    ready: "Klar", // sign up 2
    connect_accounts: "Forbind konti", // sign up 3
    explore_challenges: "Udforsk Challenges",
    explore_teams: "Udforsk hold",
    skip_to_home: "Gå til startside", // sign up 3
    remove_btn: "Fjern billede",
  },
  // Strings used globaly
  strings: {
    step: "Trin", // `Step` x of x
    of: "af", // Step x `of` x

    // Deature names, navigation, carousels etc
    challenges: "Challenges",
    challenge: "udfordring", // non uppercase
    teams: "Hold",
    team: "", // non uppercase
    news: "Nyheder",
    gathers: "Events",
    gather: "", // non uppercase
    feed: "Væg",
    friends: "Venner",
    friend: "", // non uppercase
    messages: "Beskeder",
    zones: "Zoner",
    participants: "DA: Participants", // Gathers
    interested: "DA: Interested", // Gathers
    you_havent: "Du har ikke", // Feed
    user_hasnt: "Denne bruger har ikke", // Feed
    shared_anything: "delt noget endnu", // Feed
    share_something_friends: "Del noget med dine venner...", // Placeholder-inputs
    // Will have another word like "team, challenge, news" etc at the end
    share_something_about: "DA Share something about this", // Placeholder-inputs
    share_about_yourself: "Del lidt om dig selv", // profile desc placeholder
    user_name: "Brugernavn",
    user_name_placeholder: "Vælg et brugernavn",
    full_name: "For- og efternavn",
    full_name_placeholder: "Fortæl os hvad du hedder",
    about: "Om dig",
    about_placeholder: "Fortæl os lidt om dig selv",
    upload_avatar: "Opload profilbillede",
  },
};

export default TRANSLATIONS_DA_OLD;
